import { NetworkType } from '@layerswap/widget/types';
import { getEvmConfig } from '../service/getEvmConfig';
import { createEVMTransferProvider } from './createEVMTransferProvider';
import { transactionBuilder } from './transactionBuilder';
export function createEvmTransfer() {
    const supportsNetwork = (network) => network.type === NetworkType.EVM && !!network.token;
    return {
        supportsNetwork,
        executeTransfer(params) {
            const provider = createEVMTransferProvider(getEvmConfig(), supportsNetwork, transactionBuilder);
            return provider.executeTransfer(params);
        },
    };
}
